var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type.toLowerCase() != 'mp4')?_c('img',{staticClass:"img",attrs:{"src":_vm.imageUrl}}):_vm._e(),(_vm.type.toLowerCase() == 'mp4')?_c('video',{staticClass:"video",attrs:{"id":"video","src":_vm.url,"type":"video/mp4","controls":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }